import { render } from "./CategoryBoxComp.vue?vue&type=template&id=68b438a2&scoped=true&ts=true"
import script from "./CategoryBoxComp.vue?vue&type=script&lang=ts"
export * from "./CategoryBoxComp.vue?vue&type=script&lang=ts"

import "./CategoryBoxComp.vue?vue&type=style&index=0&id=68b438a2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b438a2"]])

export default __exports__